// pontuacoes-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    ". Selecione abaixo o grupo específico (etiqueta de clientes ou clientes) para que a pontuação seja zerada": ". Seleccione abajo el grupo específico (etiqueta de clientes o clientes) para que la puntuación quede en cero",
    "Cadastrar pontuação": "Registrar puntuación",
    "Etiquetas de clientes:": "Etiquetas de clientes:",
    "Fator (pts/litro)": "Factor (pts/litro)",
    "Fatores": "Factores",
    "Intervalo (horas)": "Intervalo (horas)",
    "Manual de Pontuações": "Manual de Puntuaciones",
    "Nao foi possivel realizar a operacao, tente novamente": "No fue posible realizar la operación, intente nuevamente",
    "Nenhum combustível configurado": "Ningún combustible configurado",
    "Nenhum posto selecionado": "Ninguna estación seleccionada",
    "Pontuação criada com sucesso": "Puntuación creada con éxito",
    "Pontuação por Combustível": "Puntuación por combustible",
    "Pontuação zerada": "Puntuación en cero",
    "Pontuações por combustíveis": "Puntuaciones por combustibles",
    "Revise todas as informações antes de confirmar a criação da pontuação.": "Revise toda la información antes de confirmar la creación de la puntuación.",
    "Revisão Final da Pontuação": "Revisión final de la puntuación",
    "Se você continuar, os postos abaixo serão desvinculados de suas respectivas pontuações e incorporados à nova pontuação.": "Si continúa, las estaciones de servicio abajo se desvincularán de sus respectivas puntuaciones y se incorporarán a la nueva puntuación.",
    "Selecione etiquetas de clientes para aplicar a pontuação": "Seleccione etiquetas de clientes para aplicar la puntuación",
    "Sobrepor a pontuação padrão": "Sobrescribir la puntuación predeterminada",
    "Sobrepõe pontuação padrão": "Sobrescribe la puntuación predeterminada",
    "Tipo de Pontuação": "Tipo de puntuación",
    "Tipo de pontuação": "Tipo de puntuación",
    "Todos os fatores estão em": "Todos los factores están en",
    "Todos os postos": "Todas las estaciones",
    "apenas": "solo",
    "clientes selecionados para essa pontuação": "clientes seleccionados para esta puntuación",
    "não é permitida.": "no está permitida.",
    "para esse grupo. Sem segmentação, a regra com factor": "para ese grupo. Sin segmentación, la regla con factor",
    "pontuação padrão": "puntuación predeterminada",
    "vinculada": "vinculada",
};

export default catalogo;
